export const MOCK_CUSTOMERS = [
  { id: "cust-1", name: "L&T Construction Group" },
  { id: "cust-2", name: "Tata Power Enterprises" },
  { id: "cust-3", name: "Coimbatore Municipal Corp" },
  { id: "cust-4", name: "Peelamedu Tech Park Developer" },
];
